/**
 * Route for `payment-hold-threshold-minimum-balance-before-rele`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PaymentHoldThresholdMinimumBalanceBeforeRelePage } from "../features/payment-hold-threshold-minimum-balance-before-rele/PaymentHoldThresholdMinimumBalanceBeforeRelePage";

export const paymentHoldThresholdMinimumBalanceBeforeReleRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/payment-hold-threshold-minimum-balance-before-rele",
	component: PaymentHoldThresholdMinimumBalanceBeforeRelePage,
});

export default paymentHoldThresholdMinimumBalanceBeforeReleRoute;
